<template>
  <!-- Desktop: always show all tabs -->
  <div
    class="tw-bg-[linear-gradient(to_right,_#4294d3,_#82b132)] tw-overflow-hidden">
    <div class="marquee-container tw-whitespace-nowrap tw-py-2">
      <div class="marquee-content tw-text-white tw-uppercase">
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <span class="tw-mr-5">Betrider .</span>
        <!-- Repeat your spans as needed -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { faBullhorn, faGamepad } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { ref, onMounted, computed } from 'vue'
import { useGoldPlaySidebar } from '@/stores/goldPlaySidebar'
const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const isMobile = ref(false)
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768
}
onMounted(() => {
  checkMobile()
  window.addEventListener('resize', checkMobile)
})

const isCasinoRoute = computed(() => {
  return route.path.includes('/casino/all') || route.path.includes('/gold-play')
})

const handleGoldSlotClick = () => {
  goldPlaySidebar.toggleSidebar()
  if (!route.path.includes('/gold-play')) {
    router.push('/gold-play/NETENT')
  }
}

const handleGoldSlotClickDesktop = () => {
  if (!route.path.includes('/gold-play')) {
    router.push('/gold-play/NETENT')
  }
}

const goldPlaySidebar = useGoldPlaySidebar()
</script>

<style scoped>
.tab-group {
  transition: color 0.2s;
}

.tab-link:hover {
  color: #32d97b !important;
}

.tab-underline {
  position: absolute;
  bottom: -0.5rem;
  left: 0;
  width: 100%;
  height: 3px;
  background: #32d97b;
  transform: scaleX(0);
  transition: transform 0.3s;
}

.tab-group:hover .tab-underline {
  transform: scaleX(1);
}

.marquee-container {
  overflow: hidden;
  position: relative;
}

.marquee-content {
  display: inline-block;
  animation: marquee 25s linear infinite;
  padding-left: 50%; /* Start from the middle */
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>
